export default __webpack_public_path__ + "static/media/TIMEIN.076fe4e8.svg";